// ProjectIdUrlSync.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "./hooks";
import { setCurrentProjectIdInRedux } from "./global/globalSlice";

const extractProjectId = (pathname: string): string | null => {
  // matchar /project/:projectId/...
  const m = /^\/project\/([^/]+)/.exec(pathname);
  return m?.[1] ?? null;
};

const ProjectIdUrlSync = () => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();

  const currentProjectId = useAppSelector((state) => state.globalReducer.currentProjectId);

  useEffect(() => {
    const id = extractProjectId(pathname);
    if (currentProjectId != id) {
      dispatch(setCurrentProjectIdInRedux(id));
    }
  }, [dispatch, pathname]);

  return null;
};

export default ProjectIdUrlSync;
